import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DateTime } from 'luxon';

const MealViewer = () => {
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMeals = async () => {
      try {
        const addDays = 0;
        const startDate = DateTime.now().toFormat("MM-dd-yyyy");
        const endDate = DateTime.now().plus({days: addDays}).toFormat("MM-dd-yyyy");
        const url = `https://api.mealviewer.com/api/v4/school/Penn/${startDate}/${endDate}/0`;
        const { data } = await axios.get(
          url
        );
        setMeals(data);
        console.log(startDate,endDate)
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMeals();
  }, []);

  if (loading) return <p>Loading meals...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!meals?.menuSchedules?.length) return <p>No meals available.</p>;

  return (
    <div>
      <h1>Meals</h1>
      {meals.menuSchedules.map((schedule, index) => (
        <MealSchedule key={index} schedule={schedule} />
      ))}
    </div>
  );
};

const imageURL = 'https://custcdn.mealviewer.com/fooditemimages/';

const MealSchedule = ({ schedule }) => {
  const formattedDate = DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEE, DDD');
  const cafeteriaLines = schedule.menuBlocks;

  return (
    <div>
      <h2>{formattedDate}</h2>
      {cafeteriaLines?.length ? (
        cafeteriaLines.map((line, index) => (
          <CafeteriaLine key={index} line={line} />
        ))
      ) : (
        <p>No cafeteria lines available.</p>
      )}
    </div>
  );
};

const CafeteriaLine = ({ line }) => {
  const { blockName, cafeteriaLineList } = line;
  const foodItems = cafeteriaLineList?.data?.[0]?.foodItemList?.data || [];

  return (
    <div>
      <h3>{blockName}</h3>
      {foodItems.length > 0 ? (
        <ul>
          {foodItems.map((meal, index) => (
                meal.imageFileName ? (
                    <>
                    <li key={index}>
                    <img src={imageURL + meal.imageFileName} width={"300"} alt={meal.item_Name + ' image'}/> {meal.item_Name}</li>
                    </>
                 ) : (
                    <li key={index}>{meal.item_Name}</li>
                )
          ))}
        </ul>
      ) : (
        <p>No food items available for this block.</p>
      )}
    </div>
  );
};

export default MealViewer;
